import { Modal } from "@/utils/bootstrap";
import AuthButton from "../../../auth-common/AuthButton";
import {
  LoginMethodTypes,
  LottieFileTypes,
} from "@/api/AppApi/services/company/interfaces/ICompany";
import { accountConfirmQuery } from "../AccountConfirm";
import { usePathname } from "next/navigation";
import LottieFile from "@/app/components/lib/lottie-files/LottieFile";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  show: boolean;
  onClose: () => void;
  byEmail: boolean;
}

const ConfirmSucessModal: React.FC<Props> = ({ show, onClose, byEmail }) => {
  const isEmailVerified = byEmail;
  const pathname = usePathname();
  const router = useRouter();
  // const [showConfirm, setShowConfirm] = useState(false);
  const t = useTranslation();
  const handelOnhide = () => {
    onClose();
    router.replace("/");
  };
  const handelOnSubmit = () => {
    onClose();
    // setShowConfirm(true);
    router.replace(
      accountConfirmQuery({
        confirm: byEmail
          ? LoginMethodTypes.by_phone
          : LoginMethodTypes.by_email,
        redirectTo: pathname!,
      }),
    );
  };
  return (
    <Modal
      centered
      show={show}
      onHide={handelOnhide}
      backdrop="static"
      dialogClassName="messagebox-dialog-auth"
      contentClassName="messagebox-auth"
    >
      <div className="header-indicator" />
      <LottieFile lottieFileType={LottieFileTypes.email_verification} />
      <div className="auth-text">
        {isEmailVerified ? t.email_is_verified : t.mobile_is_verified}
      </div>
      <AuthButton onClick={handelOnSubmit}>
        {isEmailVerified ? t.verify_mobile : t.verify_email}
      </AuthButton>
      <div
        className="auth-underline-black p-0 col-auto"
        style={{ marginTop: 16 }}
        onClick={handelOnhide}
      >
        {t.skip_for_now}
      </div>
    </Modal>
  );
};

export default ConfirmSucessModal;
